import React, { useRef } from 'react';
import "./social-media-share-links.scss";
import { ISocialMediaShareLinks } from '../../../utils/types';

// The ISocialMediaShareLinks will be passed in via {...socialMediaShareLinks}
export interface SocialMediaShareLinksProps extends ISocialMediaShareLinks {
}

const SocialMediaShareLinks: React.FC<SocialMediaShareLinksProps> = (props) => {
    const pageUrl = window.location.href;
    const officeName = props.officeName;

    const text = `Check out this property I found on ${officeName} ! ${pageUrl}`;
    const shareTitle = props.shareTitle;

    const shareButton = useRef<HTMLAnchorElement>(null);
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}&title=${shareTitle}`;
    const twitterUrl = `https://twitter.com/intent/tweet?text=${text}`;
    const whatsappUrl = `https://api.whatsapp.com/send?phone=&text=${text}`;
    const shareImageUrl = props.shareImageUrl;

    const handleShareClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        console.log(`clicked shareButton: ${text} - ${shareImageUrl}`);
        shareData();
    }

    // based on - https://github.com/edysegura/html5-apis/blob/master/web-share/app.js
    // Can share to whatever sharing is enabled on the device
    const shareData = async () => {
        try {
            const shareDataText: ShareData = {
                title: shareTitle,
                text: text,
                url: pageUrl,
            };
            if (navigator.canShare && navigator.canShare(shareDataText)) {
                await navigator.share(shareDataText);
            }
        }
        catch {
            console.log("Failed to share imahe");
        }
    }

    let twitterContent = props.showTwitter ?
        (<a href={twitterUrl} target="_blank" title="Share on X (Twitter)">
            <i className="fa fa-brands fa-x-twitter"></i>
        </a >) : null;
    let whatsappContent = props.showWhatsapp ?
        (<a href={whatsappUrl} target="_blank" title="Share on WhatsApp">
            <i className="fa fa-brands fa-whatsapp"></i>
        </a >) : null;
    let facebookContent = props.showFacebook ?
        (<a href={facebookUrl} target="_blank" title="Share on Facebook">
            <i className="fa fa-brands fa-facebook"></i>
        </a >) : null;
    let shareContent = props.showShare ?
        (<a href="" target="_blank" id="shareButton" ref={shareButton} onClick={handleShareClick} title='Share Link'>
            <i className="fa-regular fa-share-from-square"></i>
        </a>) : null;

    return (<div id='socialLinks' className='socialLinks'>
        {facebookContent}
        {twitterContent}
        {whatsappContent}
        {shareContent}
    </div>);
}

export default SocialMediaShareLinks;